import { Steps } from 'antd'
import { useTranslation } from 'react-i18next'
import { SideWrapper, InfoBackground, StepperWrapper } from './styles'
import { ROUTE_FUNCTIONS } from 'modules/navigation'
import { AkaTypography } from 'components'

export enum STEPS_CHOICE {
	STEP1 = 0,
	STEP2 = 1,
	STEP3 = 2,
	STEP4 = 3,
	STEP5 = 4
}

export interface ReportSider {
	currentStep: STEPS_CHOICE
	onChange: (routeFunction: (quarter: string, id: string) => string) => void
	year: number
	quarter: number
	tenant: string
	system: string

	isHzvContractsSpecific: boolean
	requiresHzvModuleCostInfo: boolean
}

const ReportSider = ({
	currentStep,
	onChange,
	year,
	quarter,
	tenant,
	system,
	isHzvContractsSpecific,
	requiresHzvModuleCostInfo
}: ReportSider) => {
	const [t] = useTranslation()

	type StepItem = {
		step: STEPS_CHOICE
		title: string
		route: (q: string, id: string) => string
		visible: boolean
	}

	const allSteps: StepItem[] = [
		{
			step: STEPS_CHOICE.STEP1,
			title: t('approval.sidebar.stepper.step1'),
			route: ROUTE_FUNCTIONS.getSystemInfoPath,
			visible: true
		},
		{
			step: STEPS_CHOICE.STEP2,
			title: t('approval.sidebar.stepper.step2'),
			route: ROUTE_FUNCTIONS.getSystemCostsPath,
			visible: requiresHzvModuleCostInfo
		},
		{
			step: STEPS_CHOICE.STEP3,
			title: t('approval.sidebar.stepper.step3'),
			route: ROUTE_FUNCTIONS.getSelectContractRegionsPath,
			visible: isHzvContractsSpecific
		},
		{
			step: STEPS_CHOICE.STEP4,
			title: t('approval.sidebar.stepper.step4'),
			route: ROUTE_FUNCTIONS.getSelectRequirementsPath,
			visible: true
		},
		{
			step: STEPS_CHOICE.STEP5,
			title: t('approval.sidebar.stepper.step5'),
			route: ROUTE_FUNCTIONS.getJustificationsPath,
			visible: true
		}
	]

	const steps = allSteps.filter(s => s.visible)

	const adjustedCurrentStep = Math.max(
		0,
		steps.findIndex(s => s.step === currentStep)
	)

	const handleChange = (newIndex: number) => {
		const routeFn = steps[newIndex].route
		onChange(routeFn)
	}

	return (
		<SideWrapper>
			<InfoBackground>
				<AkaTypography gutterbottom={0} variant={'bodySegoe'}>
					{`${t('approval.sidebar.info.approval')}`}
					{year && <strong>{` ${year}-Q${quarter}`}</strong>}
				</AkaTypography>
				<AkaTypography gutterbottom={0} variant={'bodySegoe'}>
					{`${t('approval.sidebar.info.report')}`}
					<strong>{` ${tenant}`}</strong>
				</AkaTypography>
				<AkaTypography gutterbottom={0} variant={'bodySegoe'}>
					{`${t('approval.sidebar.info.system')}`}
					<strong>{` ${system}`}</strong>
				</AkaTypography>
			</InfoBackground>

			<StepperWrapper>
				<Steps
					current={adjustedCurrentStep}
					onChange={handleChange}
					direction="vertical"
					items={steps.map(step => ({
						title: step.title,
						style: { paddingBottom: 15 }
					}))}
				/>
			</StepperWrapper>
		</SideWrapper>
	)
}

export default ReportSider
